import { LogoIcon } from "@/icons";
import styles from "../FullscreenPresentationLayout.module.scss";
import { PresentationMembers } from "./PresentationMembers";

type PresentationHeaderProps = {
    isSpeaker: boolean;
    name: string;
    onFinish: () => void;
};

export const PresentationHeader = ({ isSpeaker, name, onFinish }: PresentationHeaderProps) => {
    return (
        <div className={styles.header}>
            <div className={styles.headerLeft}>
                <LogoIcon />
            </div>

            <div className={styles.headerCenter}>
                <span className={styles.title}>{name}</span>
            </div>

            <div className={styles.headerRight}>
                <PresentationMembers blackBackground />

                <button type="button" className={styles.finish} onClick={onFinish}>
                    {isSpeaker ? "Завершить" : "Выйти"}
                </button>
            </div>
        </div>
    );
};
